import {Injectable} from "@angular/core";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {CustomerAccountDataLoadingService} from "./customer-account-data-loading.service";
import {TranslateService} from "@ngx-translate/core";
import {AccountComponent} from "../../../crystal-clear/customer/account/account.component";

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTableConfigService {

  constructor(readonly translateService: TranslateService,
              readonly dataLoadingService: CustomerAccountDataLoadingService) {
  }

  public loadConfig(component: AccountComponent): TableColumnConfig[] {

    const tableConfig = [];
    if (!component.getIsReadOnly()) {
      tableConfig.push(
        {
          width: 30,
          type: 'BUTTON',
          notFilterable: true,
          notSortable: true,
          notResizable: true,
          class: value => 'centered',
          icon: value => value.enabled ? 'fas fa-toggle-on record-enabled' : 'fas fa-toggle-off record-disabled',
          command: (record: AccountDefinition) => {
            this.enableRecord(component, record);
          },
          mapId: value => '',
          hidden: component.getIsReadOnly()
        });
    }
    tableConfig.push(
      {
        field: 'owner',
        width: 120
      },
      {
        field: 'clearingHouse',
        width: 150
      },
      {
        field: 'exchangeCode',
        width: 150,
        icon: (record: AccountDefinition) => {
          if (this.dataLoadingService.exchangeCodes) {
            const exchField = this.dataLoadingService.exchangeCodes.find(exchange => exchange.value.code === record.exchangeCode);
            if (exchField && exchField.value)
              return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          }
          return 'fas fa-globe-europe';
        },
        mapId: record => {
          if (!record.exchangeCode || record.exchangeCode.length == 0) {
            return this.translateService.instant('page.account.form.defaultExchangeAll');
          } else {
            return record.exchangeCode
          }
        }
      },
      {
        field: 'customerName',
        width: 130,
      },
      {
        field: 'code',
        width: 130,
      },
      {
        field: 'accountTypeCode',
        width: 80
      },
      {
        field: 'reference1',
        width: 130
      },
      {
        field: 'giveUpBrokerCode',
        width: 130
      },
      {
        field: 'giveUpMessage',
        width: 130
      },
      {
        field: 'giveupAccountType',
        width: 80
      },
      {
        field: 'traderName',
        width: 130
      },
      {
        field: 'agreementId',
        width: 130
      }
    );
    if (component.hasRoles(CCRoles.ROLES_CUSTOMER_READ_ADVANCED)) {
      tableConfig.push(
        {
          field: 'moneyOwner',
          width: 130
        },
        {
          field: 'executionFee',
          width: 130
        });
    }
    tableConfig.push(
      {
        field: 'modificationDate',
        width: 100,
        format: 'dd/MM/yyyy',
        type: 'DATE',
        notFilterable: true,
      });
    return tableConfig;
  }

  enableRecord(component: AccountComponent, record: AccountDefinition) {
    component.formRecord = record;
    if (component.formRecord) {
      component.formRecord.enabled = !component.formRecord.enabled;
      component.save();
    }
  }
}
